import React from "react";
import PropTypes from "prop-types";
import { Button, Popconfirm, notification } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { withUser } from "@unifiedpatents/sso";
import useSWR from 'swr';
import { getQueries, deleteQueryById } from "../../services/api-users";
import LoadingWrapper from "./loading-wrapper";

const Queries = ({ userId, onItemClick, itemMaxChars }) => {
  // only retrieve named queries, unnamed queries are usually tied to portfolios
  const { data, error, mutate } = useSWR([`/users/${userId}/queries`, userId], () => getQueries(userId), {
    revalidateOnFocus: true
  });

  const handleDelete = async (queryId) => {
    try {
      await deleteQueryById(queryId);
      mutate(); // Refresh the data after deletion
    } catch (error) {
      notification.error({
        message: 'Failed to delete query',
        description: error.message,
        duration: 5,
      });
    }
  };

  return (
    <div>
      <style>{`
        .query-item:hover .delete-button {
          opacity: 1 !important;
        }
      `}</style>
      <LoadingWrapper loading={!data && !error} error={!!error} errorMsg="Failed to load user queries" spinSize="small">
        {data && data.length > 0
          ? data.map(({ name, updated_at, query, id }) => {
            const itemName = name || `${new Date(updated_at).toLocaleString()}`;
            return (
              <div
                key={id}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  position: 'relative'
                }}
                className="query-item"
              >
                <Button type="link" size="small" title={itemName} onClick={() => onItemClick && onItemClick(query)}>
                  {itemMaxChars && name.length > itemMaxChars ? name.slice(0, itemMaxChars) + '...' : name}
                </Button>
                <Popconfirm
                  title="Are you sure you want to delete this query?"
                  onConfirm={() => handleDelete(id)}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button
                    type="text"
                    size="small"
                    icon={<CloseOutlined />}
                    style={{
                      opacity: 0,
                      transition: 'opacity 0.2s',
                    }}
                    className="delete-button"
                  />
                </Popconfirm>
              </div>
            );
          })
          : <div style={{ opacity: 0.5 }}>No queries found</div>}
      </LoadingWrapper>
    </div>
  )
}
Queries.propTypes = {
  userId: PropTypes.string.isRequired,
  onItemClick: PropTypes.func,
  itemMaxChars: PropTypes.number,
}

const UserQueries = ({ user, onItemClick, itemMaxChars }) => {
  const userId = user.profile.user_id;
  if (!user.status.isLoggedIn || !userId) return null;
  return <Queries userId={userId} onItemClick={onItemClick} itemMaxChars={itemMaxChars} />;
};
UserQueries.propTypes = {
  onItemClick: PropTypes.func,
  itemMaxChars: PropTypes.number,
};

export default withUser(UserQueries);